import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "./../../reducers";
// import { SalesInvoiceService } from "../../../services/salesinvoice.service";
import { Combo2Service, WorkOrderService, PurchaseOrderService } from "./../../services/index";
@Component({
  selector: "addEditInvoice",
  templateUrl: "./addbitmaster.html",
})
export class addbitmaster {
  @ViewChild("tbody1") tbody1;
  row: any;
  data: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };


  codeList: any;
  seasonList: any;

  execApi: boolean = true;

  invoicedata: any = {};
  delPartyList: any;
  party_id: any;
  box: any;
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  widthList = ["36", "44", "58"];
  typeList = ["BABLA", "SHIRT"];
  sizeList = ["12-16", "36-44"];
  fitList = ["COMFORT FIT", "RELAX FIT"];
  sleeveList =["H/S","F/S"];
  designList: any;
  invalidList: any = [];
  colorList: any = [];
  qualityList: any = [];
  fabColorlist: any = [];
  fabColorTemplist: any = [];
  invoiceTypeList = ["PROFORMA", "INVOICE"];
  mode: string;
  saveEvent: any;
  agentList: any;
  bl = [];
  partyCodeList: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];

  partyList: any = [];
  styleList = ["FORMAL", "CASUAL"];
  partyOrderno: any;
  order: any;
  sale_type: any;
  expand = true;
  upd_type: any;
  listSelected = [];
  isLoadMask: Promise<any>;
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.sale_type = val["sale_type"];
    this.upd_type = val["upd_type"];
    this.saveEvent = val["data"].tabevent;
    let invoicedata = Object.assign({}, val["data"]);
    this.invoicedata = invoicedata;
    console.log(this.mode, this.upd_type);
    if (this.mode == "Convert") {
      this.invoicedata.mode = "Add";
    }

    if (this.mode == "Convert") {
      //  this.editInvoiceList();
      this.invoicedata.dcdt = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      //   this.oncheck(this.invoicedata.salesorder);
    }
    if (this.mode == "View" || this.mode == "Edit") {

      console.log(this.invoicedata, this.upd_type);
      //    this.invoicedata.dcdt = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  OrderNoCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private salesinvservice: WorkOrderService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService

  ) {
    this.row = {
      width: "",
      size: "",
      sleeve: "",
      type: "",
      mtr_from: "",
      mtr_to: "",
      rate: "",
    };
    this.data = {
      invoiceList: [],
    };
  }
  ngOnInit() {
    this.tableScroll();
    this.invoicedata.mode = this.mode;

    // if (this.mode == "Add") {

    //   this.getMasterparty();
    //   this.qualitylist();
    

    //   //this.getAuto();
    // }
  }
  ngAfterViewInit() {
    $("#invoice_type").focus();
  }
  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }



  qualitylist() {
    this.poservice.qualitylist({}).then((res: any) => {
      this.qualityList = res.data;
    });
  }
  getMasterparty() {
    this.salesinvservice.getMasterparty({}).then((res: any) => {
      this.partyList = res.data;
    });
  }
  colorlist() {
    this.poservice.colorlist({}).then((res: any) => {
      this.colorList = res.data;
    });
  }
  OnselectpartyId(type){
   let temp = this.partyList.filter(el=>el.code == type);
   this.invoicedata.party_id = temp[0].party_id;


  }
  buttonStyle() {
    const style = {
     Position : "relative",
      left: this.mode == "Add" ? "90%" : "58%",
      bottom: "54px"
    };
    return style;
  }

  addPlainDetails() {

    console.log(this.invoicedata)
    delete this.invoicedata.tabevent;
    this.data.invoiceList.push(this.invoicedata);
    console.log(this.data.invoiceList);
    var bottom = document.querySelector("#salesTbody");
    setTimeout(() => {
      bottom.scrollTop = bottom.scrollHeight;
    }, 300);

    this.invoicedata = new Object();

  }
  onEnterKeyPressed(nextEl: string) {

    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }

  }

  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.invoiceList.length >= 1) {

          that.data.invoiceList.splice(ind, 1);

          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function (dismiss) { }
    );
  }
  checkAll(evant, all) {
    if (evant.target.checked) {
      this.listSelected = this.data.invoiceList;
      $("input:checkbox").prop("checked", evant.target.checked);
    } else {
      $("input:checkbox").prop("checked", evant.target.checked);
      this.listSelected = [];
    }
  }


  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  // getAutoNumber() {

  //   this.salesinvservice.getMultiFabAuto({}).then((res: any) => {
  //     this.invoicedata.ref_no = res;
  //   });
  // }


  getTbodyStyle() {
    let height = 300;
    if (this.tbody1) {
      height -= this.tbody1.nativeElement.offsetHeight;
    }
    const style = {
      display: "block",
      width: "1px",
      height: height + "px",
      "overflow-y": "scroll",
    };
    return style;
  }
  // checkshirt_no(code) {
  //   if (code.length == 6) {
  //     if (this.execApi) {
  //       this.execApi = false;

  //       let params = {
  //         shirt_no: code,
  //       };
  //       for (let i = 0; i < this.data.invoiceList.length; i++) {
  //         // code = parseInt(code);
  //         // this.data.invoiceList[i].shirt_no = parseInt(
  //         //   this.data.invoiceList[i].shirt_no
  //         // );
  //         if (this.data.invoiceList[i].shirt_no == code) {
  //           setTimeout(() => {
  //             this.invoicedata.shirt_no = "";
  //             $("#code").focus();
  //           }, 500);

  //           swal({
  //             title: "shirt_no Already Exists",
  //             timer: 1000,
  //             type: "warning",
  //             showCancelButton: false,
  //             showConfirmButton: false,
  //           });
  //           this.execApi = true;
  //           return;
  //         }
  //       }
  //     }
  //   }
  // }

  // displayFn(comboType: string, id: number) {
  //   let list: any = [];
  //   let that = this;
  //   if (comboType == "Season") {
  //     list = this.seasonList;
  //   }

  //   if (id && list.length > 0) {
  //     let fitem = _.find(list, { season: id });
  //     this.invoicedata.season = fitem["season"];
  //     return fitem["season"];
  //   }
  //   return "";
  // }

  // oncheckemptyrow() {
  //   let design = this.data.invoiceList;
  //   let desList = [];
  //   for (let i = 0; i < design.length; i++) {
  //     if (design[i].design_no != "") {
  //       desList.push(design[i]);
  //     }
  //   }
  //   this.data.invoiceList = desList;

  //   this.onSaveInvoice();
  // }

  oncheckemptyrow(){
   
    let params: any = Object.assign({}, this.invoicedata);
    params["tabevent"] = undefined;
    params["data"] = JSON.stringify(this.data.invoiceList);
    let that = this;

    swal({
      title: "Are you sure to save this Changes?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoadMask = that.salesinvservice
        .savebitMasterDetails(params)
        .then(function (res: any) {
          if (that.saveEvent) {
            that.saveEvent.emit();
          }
          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            if (that.mode == "Add") {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          }
          else {
            swal("This Design" +" " + res.message);
          }
        })
        .catch(function (error: any) {
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
 
}
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/addbitmaster.ts